var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var BreakProps = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(BreakProps, _Declaration);

  var _super = _createSuper(BreakProps);

  function BreakProps() {
    _classCallCheck(this, BreakProps);

    return _super.apply(this, arguments);
  }

  _createClass(BreakProps, [{
    key: "prefixed",
    value:
    /**
     * Change name for -webkit- and -moz- prefix
     */
    function prefixed(prop, prefix) {
      return "".concat(prefix, "column-").concat(prop);
    }
    /**
     * Return property name by final spec
     */

  }, {
    key: "normalize",
    value: function normalize(prop) {
      if (prop.includes('inside')) {
        return 'break-inside';
      }

      if (prop.includes('before')) {
        return 'break-before';
      }

      return 'break-after';
    }
    /**
     * Change prefixed value for avoid-column and avoid-page
     */

  }, {
    key: "set",
    value: function set(decl, prefix) {
      if (decl.prop === 'break-inside' && decl.value === 'avoid-column' || decl.value === 'avoid-page') {
        decl.value = 'avoid';
      }

      return _get(_getPrototypeOf(BreakProps.prototype), "set", this).call(this, decl, prefix);
    }
    /**
     * Don’t prefix some values
     */

  }, {
    key: "insert",
    value: function insert(decl, prefix, prefixes) {
      if (decl.prop !== 'break-inside') {
        return _get(_getPrototypeOf(BreakProps.prototype), "insert", this).call(this, decl, prefix, prefixes);
      }

      if (/region/i.test(decl.value) || /page/i.test(decl.value)) {
        return undefined;
      }

      return _get(_getPrototypeOf(BreakProps.prototype), "insert", this).call(this, decl, prefix, prefixes);
    }
  }]);

  return BreakProps;
}(Declaration);

BreakProps.names = ['break-inside', 'page-break-inside', 'column-break-inside', 'break-before', 'page-break-before', 'column-break-before', 'break-after', 'page-break-after', 'column-break-after'];
module.exports = BreakProps;